module.exports = __webpack_public_path__ + "fonts/MicrogrammaD-MediExte.91a6aa9.woff";